import React from 'react'
import {subscribe} from '../../services/newsletter/subscriber';
import {withAuthentication} from '../Authentication';
import Bottom from './Bottom';
import Modal from './Modal';
import Sidebar from './Sidebar';

class Newsletter extends React.Component {
    constructor(props) {
        super(props);

        this.state = this.defaultState();
    }

    defaultState() {
        return {
            email: '',
            status: 'idle'
        };
    }

    componentWillReceiveProps(newProps) {
        if (newProps.advertiser !== this.props.advertiser || newProps.category !== this.props.category) {
            this.setState(this.defaultState());
        }
    }

    resetSessionEmail(event) {
        event.preventDefault();
        this.props.logout();
        this.setState({email: ''});
    }

    setEmail(event) {
        this.setState({email: event.target.value});
    }

    onSubmit(event) {
        event.preventDefault();
        this.setState({status: 'loading'}, () => {
            subscribe(
                this.props.email ? this.props.email : this.state.email,
                window.location.href,
                this.props.source,
                this.props.advertiser ? this.props.advertiser.slug : '',
                this.props.category ? this.props.category.slug : ''
            )
                .then(() => {
                    this.props.setEmail(this.props.email ? this.props.email : this.state.email);
                    this.setState({status: 'success'});
                })
                .catch(() => {
                    this.setState({status: 'error'});
                })
        });
    }

    render() {
        return React.Children.map(this.props.children,
            (child) => React.cloneElement(child, {
                onSubmit: this.onSubmit.bind(this),
                setEmail: this.setEmail.bind(this),
                resetSessionEmail: this.resetSessionEmail.bind(this),
                status: this.state.status,
                email: this.state.email,
                advertiser: this.props.advertiser,
                category: this.props.category,
                sessionEmail: this.props.email
            })
        );
    }
}

Newsletter.defaultProps = {
    source: 'site',
    advertiser: '',
    category: ''
};

const withNewsletter = (WrappedComponent) => {
    return ({...props}) => {
        return <Newsletter {...props}>
            <WrappedComponent/>
        </Newsletter>
    }
};


const NewsletterBottom = withAuthentication(withNewsletter(Bottom));
const NewsletterSidebar = withAuthentication(withNewsletter(Sidebar));
const NewsletterModal = withAuthentication(withNewsletter(Modal));

export {NewsletterBottom, NewsletterSidebar, NewsletterModal};
